import React, { useState } from "react";
import { api } from "../lib/api";

const KEY = "ak_gate_ok";

export default function AccessGate({ children }) {
  const [open, setOpen] = useState(() => sessionStorage.getItem(KEY) === "1");
  const [code, setCode] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (open) return children;

  const submit = async (e) => {
    e.preventDefault();
    if (!code.trim()) return;
    setLoading(true);
    setError("");
    try {
      await api.post("/gate/verify", { code });
      sessionStorage.setItem(KEY, "1");
      setOpen(true);
    } catch (err) {
      setError(err?.response?.data?.detail || "That code isn't right. Please try again.");
      setCode("");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F8F2E8] text-[#1F1B18] flex flex-col items-center justify-center px-6" data-testid="access-gate">
      <p className="font-cormorant text-2xl sm:text-3xl tracking-[0.35em] uppercase">Ask Kimberley</p>
      <p className="font-typewriter text-xs sm:text-sm tracking-[0.4em] uppercase text-[#8B6B4A] mt-10">Private preview</p>
      <h1 className="font-cormorant font-light leading-tight mt-4 text-center" style={{ fontSize: "clamp(2rem, 4vw, 3.25rem)" }}>
        Please enter your <span className="italic text-[#D9739A]">access code.</span>
      </h1>

      <form onSubmit={submit} className="mt-12 w-full max-w-sm flex flex-col items-center" data-testid="access-gate-form">
        <input
          type="password"
          value={code}
          onChange={(e) => setCode(e.target.value)}
          placeholder="Access code"
          autoFocus
          autoComplete="off"
          data-testid="access-gate-input"
          className="w-full bg-transparent border-b border-[#1F1B18]/40 px-2 py-3 text-center font-cormorant italic text-2xl placeholder-[#1F1B18]/35 focus:outline-none focus:border-[#D9739A] transition"
        />
        {error && (
          <p className="font-cormorant italic text-lg text-[#D9739A] mt-4" role="alert" data-testid="access-gate-error">
            {error}
          </p>
        )}
        <button
          type="submit"
          disabled={loading}
          data-testid="access-gate-submit"
          className="mt-10 inline-flex items-center gap-3 bg-[#1F1B18] text-[#F8F2E8] px-10 py-4 rounded-full font-typewriter text-sm tracking-[0.25em] uppercase hover:bg-[#D9739A] transition-colors duration-300 disabled:opacity-50"
        >
          {loading ? "…" : "Enter"} <span className="text-[#D9739A]">⟶</span>
        </button>
      </form>

      <p className="font-typewriter text-[11px] tracking-[0.3em] uppercase text-[#1F1B18]/40 mt-16">By invitation only</p>
    </div>
  );
}
